import React from "react";
import { useTranslation } from "react-i18next";

export default function Controls() {
  const { t } = useTranslation();
  return (
    <div className="controls">
      <h1>{t("translation:available_order_processors")}</h1>
    </div>
  );
}
